import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  paper: {
    margin: "3% auto",
    width: "60%",
    minHeight: "30%",
    maxWidth: "90%",
    maxHeight: "90%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "3px",
    boxShadow: theme.shadows[5],
    outline: 0,
    overflowY: "scroll",
  },
  fullWidth: {
    margin: "3% auto",
    width: "90%",
    minHeight: "30%",
    maxWidth: "90%",
    maxHeight: "90%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "3px",
    boxShadow: theme.shadows[5],
    outline: 0,
    overflowY: "scroll",
  },
  closeIcon: {
    color: theme.appbar.text,
    cursor: "pointer",
  },
  modalTitle: {
    fontWeight: "500",
    color: theme.appbar.text,
  },
  perSectionWrapper: {
    backgroundColor: theme.palette.background.default,
    padding: "1rem 0.8rem",
    borderRadius: "0.2rem",
    margin: "1rem 0",
  },
  sectionTitle: {
    paddingBottom: "0.9rem",
    marginTop: "0px",
    color: theme.palette.text.primary,
  },
  fieldsGrid: {
    marginTop: theme.spacing(2),
  },
  modal: {
    outline: "none",
  },
  buttonsWrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
  titleHeadWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0.8rem 1.2rem",
    position: "sticky",
    top: 0,
    backgroundColor: theme.appbar.background,
    zIndex: 101,
  },
  progressWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  adornment: {
    padding: 0,
    margin: 0,
    cursor: "pointer",
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.main,
  },
}));
